import { DateTime as DateTime$1 } from "../../../components/DateTime/index.js";
import { IdLabel } from "../../../components/IdLabel/index.js";
import { ImageSmall } from "../../../components/ImageSmall/index.js";
import { Tags } from "../../Tags/shared/Tags.js";
import "react";
import { Card } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
//#region src/modules/Records/shared/RecordListCard.tsx
function RecordListCard({ active, description, idLabel, lastActivity, onClick, orientation = "horizontal", primaryImageUrl, tags, title, type }) {
	return /* @__PURE__ */ jsxs(Card, {
		className: classnames({ "flex flex-col sm:flex-row": orientation === "horizontal" }, "bg-surface gap-xxs relative"),
		onClick,
		padding: "sm",
		space: "0",
		children: [
			!!active && /* @__PURE__ */ jsx("div", { className: "from-main-faded absolute inset-0 bg-linear-to-bl via-transparent via-80% sm:bg-linear-to-l" }),
			!!primaryImageUrl && /* @__PURE__ */ jsx("div", {
				className: "relative shrink-0",
				children: /* @__PURE__ */ jsx(ImageSmall, {
					className: classnames({ "sm:mr-sm sm:mb-0 sm:h-25 sm:w-25 sm:object-cover": orientation === "horizontal" }, "mb-sm max-h-38 object-contain object-top"),
					lightbox: false,
					src: primaryImageUrl,
					fluid: true,
					rounded: true
				})
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "isolate flex grow flex-col",
				children: [
					/* @__PURE__ */ jsxs("div", {
						className: classnames({ "sm:gap-x-sm flex-col-reverse sm:flex-row sm:items-center": orientation === "horizontal" }, "flex flex-col-reverse flex-wrap-reverse justify-between"),
						children: [/* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx("span", {
							className: "mr-xs text-md font-medium break-all",
							children: title
						}), /* @__PURE__ */ jsx(IdLabel, {
							className: "text-color-subtle text-sm font-bold tracking-wide",
							idLabel
						})] }), !!lastActivity && /* @__PURE__ */ jsxs("span", {
							className: "text-color-subtle text-xs",
							children: ["Last activity ", /* @__PURE__ */ jsx(DateTime$1, {
								relative: true,
								timestamp: lastActivity
							})]
						})]
					}),
					/* @__PURE__ */ jsx("div", { className: "mt-xxs border-border border-t" }),
					/* @__PURE__ */ jsxs("div", {
						className: classnames({ "sm:text-base": orientation === "horizontal" }, "mt-sm grow text-sm"),
						children: [!!type && /* @__PURE__ */ jsxs("span", {
							className: "text-color-subtle rounded font-medium tracking-wide capitalize",
							children: [type, " "]
						}), /* @__PURE__ */ jsx("span", {
							className: "break-all",
							children: description
						})]
					}),
					!!tags?.length && /* @__PURE__ */ jsx("div", {
						className: "mt-xxs",
						children: /* @__PURE__ */ jsx(Tags, {
							tags,
							max: 3
						})
					})
				]
			})
		]
	});
}
//#endregion
export { RecordListCard };

//# sourceMappingURL=RecordListCard.js.map